import ForgotPasswordView from "../auth/views/ForgotPasswordView";
import { Stack } from "expo-router";
import { PublicGuard } from "../auth/guards/RouteGuards";

export const unstable_settings = {
  headerShown: false,
};

export default function ForgotPassword() {
  return (
    <PublicGuard>
      <Stack.Screen options={{ headerShown: false }} />
      <ForgotPasswordView />
    </PublicGuard>
  );
}
